import { SurveyName } from '@reviews/interfaces';
import _ from 'lodash';

export const getDisposition = (starRating: string | null): SurveyName => {
    const isNegative = !_.isNil(starRating) && !_.isEmpty(starRating) && _.toNumber(starRating) < 4;
    return isNegative ? SurveyName.REVIEW_NEGATIVE_DISPOSITION : SurveyName.REVIEW_POSITIVE_DISPOSITION;
};
